"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: function root(_ref2) {
      var isActive = _ref2.isActive;
      return {
        borderRadius: 5,
        border: "solid 2px ".concat(isActive ? palette.secondary.main : palette.grey.timberWolf),
        marginTop: spacing(1),
        padding: spacing(3)
      };
    },
    label: {
      width: '100%'
    },
    editLink: {
      fontSize: 12,
      fontFamily: 'Lato',
      fontWeight: 'bold',
      color: palette.link.main,
      width: 50,
      cursor: 'pointer'
    },
    icon: {
      marginRight: spacing(0.5)
    }
  };
});

var AddressRadioOption = function AddressRadioOption(_ref3) {
  var label = _ref3.label,
      value = _ref3.value,
      isActive = _ref3.isActive,
      onEdit = _ref3.onEdit;
  var classes = useStyles({
    isActive
  });
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    className: classes.label,
    value: value,
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, {
      color: "primary"
    }),
    label: label
  }), onEdit && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.editLink,
    onClick: onEdit
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    className: classes.icon,
    icon: "pencil",
    fontSize: 0.8
  }), "Edit")));
};

var _default = AddressRadioOption;
exports.default = _default;